import React from "react";
import {useParams} from "react-router-dom";
import {AdminLayoutFullHeightAndTwoCells} from "../../atoms/admin-layout";
import {DocumentTitle} from "../../atoms/document-title";
import {Spinner} from "../../atoms/spinner";
import {useSsoConfigurationQuery} from "./hooks";
import {FacilityCodesCard} from "./FacilityCodesCard";
import {SsoConfigurationCard} from "./SsoConfigurationCard";
import {SSOManagementCardGroup} from "./SSOManagementCardGroup";
import {ApplicationDetailsCard} from "./ApplicationDetailsCard";
import {NoCreatedSsoConfigurationFoundCard} from "./NoCreatedSsoConfigurationFoundCard";

const SSO_CONFIGURATION_PAGE_TITLE = "Reside - Admin - SSO Configuration";

/**
 * Displays SSO configuration details and application settings.
 * Redirects to create page if no config exists.
 */
export const PageAdminSsoConfiguration = () => {
  const {organizationId} = useParams<{organizationId: string}>();
  const {data: ssoConfig, isLoading} = useSsoConfigurationQuery();

  const renderPageContent = () => {
    if (isLoading) return <Spinner />;

    if (!ssoConfig)
      return (
        <NoCreatedSsoConfigurationFoundCard organizationId={organizationId} />
      );

    return (
      <>
        <SsoConfigurationCard
          ssoConfig={ssoConfig}
          organizationId={organizationId}
        />
        <ApplicationDetailsCard ssoConfig={ssoConfig} />
        <SSOManagementCardGroup
          ssoEnabled={ssoConfig.ssoEnabled}
          ssoExcludeRequiredRoles={ssoConfig.ssoExcludeRequiredRoles}
        />
        <br />
        <FacilityCodesCard />
      </>
    );
  };

  return (
    <AdminLayoutFullHeightAndTwoCells>
      <DocumentTitle title={SSO_CONFIGURATION_PAGE_TITLE} />

      {renderPageContent()}
    </AdminLayoutFullHeightAndTwoCells>
  );
};
